<div class="__main-container pb3">
	<div class="__header">
		<span
			>Políticas de Seguridad y Privacidad de la Información, Tratamiento de
			Datos Personales y Términos y Condiciones</span
		>
	</div>
	<strong>Términos y Condiciones de Uso</strong>
	<br /><br />
	La Gobernación del Valle del Cauca (en adelante la entidad) cuenta con una
	página web con URL: https://www.valledelcauca.gov.co (en adelante el Sitio
	Web), que tiene como función principal garantizar el acceso a la información
	pública a los ciudadanos, proveer información noticiosa de interés para la
	comunidad, visibilizar las políticas, planes, programas y proyectos
	institucionales, divulgar y promocionar las iniciativas, convocatorias,
	eventos o actividades producto del cumplimiento de la misionalidad u objetivos
	de la entidad, así como posibilitar la relación de los ciudadanos con la
	entidad a través de medios digitales.
	<br /><br />
	En ese sentido, la Gobernación del Valle del Cauca solicita al visitante y al
	usuario de esta página, que lean detallada y juiciosamente estas condiciones,
	las políticas y procedimientos para el tratamiento de datos personales y la
	política de seguridad de la información, antes de iniciar su exploración o
	utilización, y en caso de no estar de acuerdo con estas condiciones o con
	cualquier disposición de la política de privacidad, le sugerimos que se
	abstenga de acceder o navegar por la página Web de nuestra entidad.
	<br /><br /><br />
	<strong>1. Aceptación de Términos</strong>
	<br /><br />
	Cuando un usuario accede a la página Web de la entidad, lo hace bajo su total
	responsabilidad y, por tanto, acepta plenamente y sin reservas el contenido de
	los términos y condiciones de uso de la página Web de la entidad estatal. La
	entidad se reserva, en todos los sentidos, el derecho de actualizar y
	modificar en cualquier momento y de cualquier forma, de manera unilateral y
	sin previo aviso, las presentes condiciones de uso y los contenidos de la
	página.
	<br /><br />
	La prestación del servicio de la página de la entidad, es de carácter libre y
	gratuito para los usuarios y se rige por los términos y condiciones que se
	incluyen a continuación, los cuales se entienden como conocidos y aceptados
	por los usuarios del sitio:
	<br /><br />
	<strong>2. Derechos de autor (Copyright)</strong>
	<br /><br />
	Esta página de Internet y su contenido institucional, incluyendo los textos,
	gráficos, logos, animaciones y sonidos, son de propiedad de la entidad. Está
	prohibida su reproducción total o parcial, su traducción, inclusión,
	transmisión, almacenamiento o acceso a través de medios analógicos, digitales
	o de cualquier otro sistema o tecnología creada, sin autorización previa y
	escrita de la entidad.
	<br /><br />
	Los usuarios pueden recuperar, exhibir, imprimir, copiar o descargar cualquier
	material de este sitio exclusivamente para uso personal y no comercial,
	siempre y cuando se haga expresa mención de la propiedad en cabeza de la
	Gobernación del Valle del Cauca.
	<br /><br />
	Con respecto a los contenidos que aparecen en la página Web de la entidad, el
	usuario se obliga a:
	<br /><br />
	- Usar los contenidos de forma diligente, correcta y lícita. - No suprimir,
	eludir, o manipular el derechos de autor (copyright) y demás datos que
	identifican los derechos de la entidad. - No emplear los contenidos y, en
	particular, la información de cualquier otra clase obtenida a través de la
	Gobernación del Valle del Cauca, o de los servicios, para emitir publicidad. -
	La entidad no será responsable por el uso indebido que hagan los usuarios del
	contenido de su página Web. El visitante o usuario de la página Web se hará
	responsable por cualquier uso indebido, ilícito o anormal que haga de los
	contenidos, información o servicios de la página Web. - El visitante o usuario
	del sitio, directa o por interpuesta persona, no atentará de ninguna manera
	contra la página Web de la entidad, contra su plataforma tecnológica, contra
	sus sistemas de información ni tampoco interferirá en su normal
	funcionamiento. - El visitante o el usuario del sitio, no alterará, bloqueará
	o realizará cualquier otro acto que impida mostrar o acceder a cualquier
	contenido, información o servicios del sitio Web o que estén incorporados en
	las páginas Web vinculadas a la de la entidad. - El visitante o el usuario de
	la página Web no enviará o transmitirá en este sitio Web o hacia el mismo, a
	otros usuarios o a cualquier persona, cualquier información de alcance
	obsceno, difamatorio, injuriante, calumniante o discriminatorio contra la
	entidad, contra sus funcionarios o contra los responsables de la
	administración de la página Web. - El visitante o el usuario de la página Web,
	no incurrirá en y desde el mismo, en conductas ilícitas como daños o ataques
	informáticos, interceptación de comunicaciones, infracciones al derecho de
	autor, uso no autorizado de terminales, usurpación de identidad, revelación de
	secretos o falsedad en los documentos.
	<br /><br />
	Asimismo, queda absolutamente prohibido ingresar comentarios, mensajes,
	opiniones, información, o similares, de contenido difamatorio, abusivo,
	contrario a la moral y las buenas costumbres, discriminatorio, ofensivo,
	obsceno, intimidatorio, calumnioso, inapropiado, ilegal, violatorio de
	derechos de terceros de cualquier índole, incluidos los derechos de los
	menores de edad, que cause daños y/o perjuicios, o impida o limite el derecho
	propio o ajeno a usar los Espacios y demás capítulos del sitio, constituya un
	delito o apología a un delito y/o incite a la violencia y/o a la comisión de
	delitos. Tampoco está permitido publicitar productos y/o servicios de
	cualquier tipo dentro de "los espacios", ni utilizar o enviar virus, o
	desviarse de los temas propuestos en los foros.
	<br /><br />
	Ahora bien, en el supuesto de que este tipo de comentarios, mensajes,
	opiniones, información, o similares, ingrese en "los espacios", los usuarios,
	aceptan en forma expresa e incondicionada que la entidad, sus empleados,
	proveedores, o anunciantes, NO serán responsables en modo alguno por las
	consecuencias de cualquier tipo y alcance que los mismos pudieran generar,
	frente a cualquier tercero, ya sea en virtud de su inclusión dentro de "los
	espacios" o por cualquier causa relacionada directa o indirectamente con el
	uso de los mismos.
	<br /><br />
	Asimismo, la entidad, sus empleados, proveedores o anunciantes, NO serán
	responsables de modo alguno en el supuesto que los comentarios, información,
	mensajes, opiniones, o similares, se vean afectados, eliminados, alterados, o
	modificados de alguna manera.
	<br /><br />
	<strong>3. Uso del sitio web por parte de los menores de edad</strong>
	<br /><br />
	Los menores de 18 años o personas sujetas a tutela o curaduría no podrán
	ingresar ni utilizar los servicios ofrecidos a través de estas páginas sin la
	autorización previa de sus padres, tutores o curadores. Asimismo, no podrán
	registrarse por cuenta propia para acceder a los servicios del sitio web,
	salvo que cuenten con dicho consentimiento, según corresponda.
	<br /><br />
	El Ministerio/Fondo Único de Tecnologías de la Información y las
	Comunicaciones manifiesta, de conformidad con lo dispuesto en el Código del
	Menor y demás normas aplicables, que el objeto de estas páginas no es atentar
	contra la moral ni la salud física o mental de los menores de edad o personas
	sujetas a tutela o curaduría, ni obtener información confidencial o íntima de
	los usuarios con fines de uso indebido o en su perjuicio.
	<br /><br />
	Los padres, tutores o curadores de los usuarios menores de edad o personas
	sujetas a tutela o curaduría serán plenamente responsables por el uso que
	estos hagan de la plataforma.
	<br /><br />
	<strong>4. Privacidad</strong>
	<br /><br />
	La Gobernación del Valle del Cauca, se compromete a salvaguardar la privacidad
	de la información personal del Usuario obtenida a través de la página Web de
	la entidad, para lo cual adopta una política de confidencialidad, así como una
	política de protección de datos personales, de acuerdo con lo que se establece
	en las políticas y procedimientos para el tratamiento de datos personales.
	<br /><br />
	Se entiende por información personal aquella suministrada por el Usuario para
	el registro, la cual incluye datos como nombre, identificación, edad, género,
	dirección, correo electrónico y teléfono.
	<br /><br />
	El Usuario reconoce que el ingreso de información personal, lo realiza de
	manera voluntaria y ante la solicitud de requerimientos específicos por parte
	de la Gobernación del Valle del cauca, con la finalidad de realizar un
	trámite, presentar una queja o reclamo, o para acceder a los mecanismos
	interactivos.
	<br /><br />
	Con ocasión de un trámite o servicio desarrollado por medios Electrónicos, la
	Entidad podrá solicitar información a los Usuarios del Sitio Web y la tratara
	con todas las garantías legales y de seguridad que impone la Constitución
	Política, las normas aplicables a la protección de datos de carácter personal
	y demás normas concordantes. La solicitud de información se hace siempre para
	que el Usuario la suministre de manera voluntaria.
	<br /><br />
	La entidad se compromete a no ceder, vender, ni a compartir los datos
	recibidos en el Sitio Web con terceros sin su aprobación expresa. Las
	entidades adscritas no se considerarán terceros para estos efectos. Así mismo,
	la entidad cancelará o rectificará los datos cuando resulten inexactos,
	incompletos o hayan dejado de ser necesarios o pertinentes para su finalidad.
	<br /><br />
	El Usuario Registrado se compromete a notificar a la Gobernación del Valle del
	Cauca, en forma inmediata y por medio fehaciente, cualquier uso no autorizado
	de su clave, en la sede electrónica.
	<br /><br />
	<strong>5. Información y sitios Web de terceros</strong>
	<br /><br />
	La página Web puede ofrecer hipervínculos o acceso a páginas Web y contenidos
	de otras personas o entidades, con el propósito de informar al Usuario sobre
	la existencia de otras fuentes susceptibles de ampliar los contenidos que ésta
	ofrece, o que guardan relación con aquéllos. En ese sentido, la entidad no
	controla, refrenda ni garantiza el contenido incluido en dichos sitios,
	tampoco se responsabiliza del funcionamiento o accesibilidad de las páginas
	Web vinculadas; ni sugiere, invita o recomienda la visita a las mismas, por lo
	que tampoco será responsable del resultado obtenido.
	<br /><br />
	El Usuario acepta que la entidad no es responsable de ningún contenido, enlace
	asociado, recurso o servicio relacionado con el sitio de un tercero. Asimismo,
	el Usuario acepta que la entidad no será responsable de ninguna pérdida o daño
	de cualquier tipo que se derive del uso que se realice de los contenidos de un
	tercero.
	<br /><br />
	La entidad, no se responsabiliza por cualquier consecuencia derivada del
	ingreso indebido de terceros a la base de datos y/o por alguna falla técnica
	en el funcionamiento y/o conservación de datos en el sistema en cualquiera de
	<br /><br />
	Igualmente, la entidad no podrá garantizar la disponibilidad de los servicios
	en línea y de la información que los usuarios requieran en determinado
	momento. Tampoco incurrirá en responsabilidad con el usuario o terceros,
	cuando su página Web no se encuentre disponible.
	<br /><br />
	La entidad, no responderá en ningún caso y bajo ninguna circunstancia, por los
	ataques o incidentes contra la seguridad de su página Web o contra sus
	sistemas de información; o por cualquier exposición o acceso no autorizado,
	fraudulento o ilícito a su página Web y que puedan afectar la
	confidencialidad, integridad o autenticidad de la información publicada o
	asociada con los contenidos y servicios que se ofrecen en ella.
	<br /><br />
	<strong>6. Responsabilidad por la información contenida</strong>
	<br /><br />
	Debido a que en la actualidad los medios técnicos no permiten garantizar la
	absoluta falta de injerencia de la acción de terceras personas en las páginas
	Web, la entidad de ninguna manera asegura la exactitud y/o veracidad de todo o
	parte de la información contenida en su página, ni su actualización, ni que
	dicha información haya sido alterada o modificada en todo o en parte, luego de
	haber sido publicada en la página, ni cualquier otro aspecto o característica
	de lo publicado en el sitio o en los enlaces, respectivamente.
	<br /><br />
	La entidad no controla ni garantiza la ausencia de virus ni de otros elementos
	en los contenidos que puedan producir alteraciones en su sistema informático
	(software y hardware) o en los documentos electrónicos y ficheros almacenados
	en su sistema informático.
	<br /><br />
	<strong>7. Ley aplicable y jurisdicción</strong>
	<br /><br />
	1. El usuario no podrá manifestar ante la entidad o ante una autoridad
	judicial o administrativa, la aplicación de condición, norma o convenio que no
	esté expresamente incorporado en las presentes condiciones de uso.
	<br /><br />
	2. Estas condiciones serán gobernadas por las leyes de la República de
	Colombia, en los aspectos que no estén expresamente regulados en ellas.
	<br /><br />
	3. Si cualquier disposición de estas condiciones pierde validez o fuerza
	obligatoria, por cualquier razón, todas las demás disposiciones, conservan su
	fuerza obligatoria, carácter vinculante y generarán todos sus efectos. Para
	cualquier efecto legal o judicial, el lugar de las presentes condiciones es la
	ciudad de Cali, República de Colombia, y cualquier controversia que surja de
	su interpretación o aplicación se someterá a los jueces de la República de
	Colombia.
	<br /><br /><br />
	<strong
		>Políticas de Seguridad y Privacidad de la Información, Tratamiento de Datos
		Personales</strong
	>
	<br /><br />
	A continuación se presentan los documentos de las
	<strong
		>Políticas de Seguridad y Privacidad de la Información y de Tratamiento de
		Datos Personales.</strong
	>
	<br />
	Le invitamos a revisarlos detenidamente antes de continuar. Al aceptar, usted
	manifiesta su conformidad y acepta los términos y condiciones establecidos en
	dichos documentos.
	<br /><br />
	<a
		href="https://www.valledelcauca.gov.co/loader.php?lServicio=Tools2&lTipo=viewpdf&id=114804"
		target="_blank"
		class="mb1"
	>
		<mat-icon>description</mat-icon>
		Políticas de Seguridad y Privacidad de la Información
	</a>
	<a
		href="https://www.valledelcauca.gov.co/loader.php?lServicio=Tools2&lTipo=viewpdf&id=114805"
		target="_blank"
	>
		<mat-icon>description</mat-icon>
		Política de Tratamiento de Datos Personales
	</a>
</div>